import { render, staticRenderFns } from "./personInfoForm.vue?vue&type=template&id=f4748276&scoped=true&"
import script from "./personInfoForm.vue?vue&type=script&lang=ts&"
export * from "./personInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./personInfoForm.vue?vue&type=style&index=0&id=f4748276&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4748276",
  null
  
)

export default component.exports